import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinnhavareshirur() {



const cardData =
  {
    keyword: 'Bus On Rent in Nhavare Shirur',
    heading: 'Sanavi Travels: Bus On Rent in Nhavare Shirur',
    headingDescription: 'Sanavi Travels offers professional, safe, and well-managed Bus On Rent in Nhavare Shirur, serving families, wedding groups, corporate teams, schools, picnic travelers, devotees, and outstation passengers. Nhavare is a prominent village in Shirur taluka of Pune district, strategically located near agricultural belts and well-connected to Shirur town, Ranjangaon MIDC, Pune–Ahmednagar highway, and surrounding rural areas. Due to frequent weddings, social gatherings, educational tours, industrial travel, and long-distance journeys, the demand for organized group transportation in Nhavare is consistently high. To meet these requirements, Sanavi Travels provides a wide fleet of AC buses, Non-AC buses, luxury coaches, mini buses, and high-capacity buses designed for both short village travel and long outstation routes. Every vehicle is maintained with clean interiors, comfortable seating, proper ventilation, smooth suspension, and sufficient luggage space to ensure a relaxed and secure travel experience. Our skilled drivers are well-versed with Nhavare village roads, Shirur routes, industrial corridors, and highways, ensuring punctual pickups, safe driving, and seamless navigation. With transparent pricing, flexible rental plans, and 24/7 customer assistance, Sanavi Travels makes bus rental in Nhavare Shirur dependable, affordable, and stress-free for every travel purpose.',

    top: 'Top Places to Visit Near Nhavare Shirur with Sanavi Travels',


"topPlaces": [
  {
    "title": "Nhavare Village Area",
    "description": "Nhavare is a vibrant rural settlement known for agriculture, social harmony, and frequent community events. The village regularly hosts weddings, religious programs, and family functions that require reliable group transportation. Bus rentals help villagers and guests travel together comfortably, avoiding the hassle of arranging multiple small vehicles."
  },
  {
    "title": "Shirur Town",
    "description": "Shirur town is the nearest commercial center for Nhavare residents, offering markets, banks, hospitals, educational institutions, and transport facilities. Group travel to Shirur for official work, shopping, and events is common, and bus hire services provide organized, punctual, and economical transportation."
  },
  {
    "title": "Ranjangaon MIDC",
    "description": "Ranjangaon MIDC is a major industrial hub near Nhavare, employing a large workforce from surrounding villages. Many companies rely on bus rentals for employee transportation, shift travel, training programs, and corporate movement, ensuring discipline, safety, and punctuality."
  },
  {
    "title": "Agricultural Farmland",
    "description": "Nhavare is surrounded by fertile farmland cultivating sugarcane, vegetables, and seasonal crops. Farmers and cooperative members frequently travel together for meetings, market visits, and agricultural programs, where bus rentals offer economical and coordinated transport."
  },
  {
    "title": "Nearby Temples and Religious Sites",
    "description": "Local temples around Nhavare attract devotees during festivals, yatras, and special occasions. Bus hire services are commonly used for group temple visits, ensuring peaceful and comfortable journeys for elderly devotees and families."
  },
  {
    "title": "School and College Travel",
    "description": "Students from Nhavare travel to Shirur, Pune, and nearby towns for educational tours, competitions, and cultural programs. Bus rentals provide safe, supervised, and timely transportation for schools and colleges."
  },
  {
    "title": "Wedding and Event Venues",
    "description": "Marriage halls and open venues in and around Nhavare generate significant demand for guest transportation. Hiring buses ensures guests arrive on time, travel together, and enjoy smooth coordination during large events."
  },
  {
    "title": "Picnic and Leisure Destinations",
    "description": "Families, schools, and organizations from Nhavare often plan picnic trips to nearby scenic spots. Bus rentals allow groups to travel safely while enjoying the journey without worrying about traffic or parking."
  },
  {
    "title": "Pune–Ahmednagar Highway Access",
    "description": "Nhavare has convenient access to the Pune–Ahmednagar highway, making it ideal for long-distance travel. Bus rentals provide stability, comfort, and cost efficiency for highway journeys."
  },
  {
    "title": "Outstation Travel Routes",
    "description": "Nhavare serves as a starting point for outstation trips to Pune, Ahmednagar, Nashik, and pilgrimage destinations. Bus rentals ensure a relaxed, economical, and well-organized travel experience for long journeys."
  }
]
,



"services": [
{
"name": "Bus On Rent in Nhavare Shirur",
"description": "Bus On Rent in Nhavare Shirur provides dependable, spacious, and professionally managed buses for weddings, corporate travel, school trips, picnics, religious tours, and outstation journeys. Our buses are equipped with clean interiors, cushioned seating, smooth suspension, proper airflow, and adequate luggage space to ensure passenger comfort across short and long routes. With experienced drivers familiar with village roads, industrial zones, and highways, group travel becomes safe, punctual, and stress-free. This service is ideal for families, organizations, and institutions seeking reliable transportation."
},
{
"name": "Bus Hire Nhavare Shirur",
"description": "Bus Hire Nhavare Shirur offers flexible rental options for local, full-day, and long-distance travel. Well-maintained buses and disciplined drivers ensure smooth and economical group movement."
},
{
"name": "AC Bus Rental Nhavare Shirur",
"description": "AC Bus Rental Nhavare Shirur provides air-conditioned comfort for summer travel and long journeys, ensuring reduced fatigue and a pleasant travel environment."
},
{
"name": "Non AC Bus on Rent Nhavare Shirur",
"description": "Non AC Bus on Rent Nhavare Shirur is a budget-friendly option for short routes, rural travel, school trips, and local events without compromising safety."
},
{
"name": "Luxury Bus on Rent Nhavare Shirur",
"description": "Luxury Bus on Rent Nhavare Shirur offers premium interiors, superior seating, and enhanced comfort, ideal for weddings, VIP guests, and corporate executives."
},
{
"name": "Mini Bus Hire Nhavare Shirur",
"description": "Mini Bus Hire Nhavare Shirur is suitable for small to medium groups such as families, office teams, and students, providing flexibility and affordability."
},
{
"name": "32 Seater Bus on Rent Nhavare Shirur",
"description": "32 Seater Bus on Rent Nhavare Shirur is ideal for school outings, corporate tours, and medium-sized group travel with balanced comfort."
},
{
"name": "35 Seater Bus Hire Nhavare Shirur",
"description": "35 Seater Bus Hire Nhavare Shirur supports large group transportation needs such as weddings, pilgrimages, and long-distance travel."
},
{
"name": "Bus on Rent Nhavare Shirur for Wedding",
"description": "Bus on Rent Nhavare Shirur for Wedding ensures smooth and coordinated transportation for wedding guests, reducing logistical challenges."
},
{
"name": "Bus on Rent Nhavare Shirur for Corporate",
"description": "Bus on Rent Nhavare Shirur for Corporate provides professional transport for employee movement, meetings, conferences, and corporate outings."
},
{
"name": "Bus on Rent Nhavare Shirur for Picnic",
"description": "Bus on Rent Nhavare Shirur for Picnic offers safe and enjoyable travel for schools, families, and organizations planning leisure trips."
},
{
"name": "Bus Rental Nhavare Shirur Outstation",
"description": "Bus Rental Nhavare Shirur Outstation provides reliable long-distance transportation to Pune, Ahmednagar, Nashik, and nearby cities."
},
{
"name": "Bus Hire Nhavare Shirur with Driver",
"description": "Bus Hire Nhavare Shirur with Driver offers chauffeur-driven buses where skilled drivers manage routes, traffic, and schedules efficiently."
},
{
"name": "Affordable Bus Rental Nhavare Shirur",
"description": "Affordable Bus Rental Nhavare Shirur delivers cost-effective transportation without compromising comfort, cleanliness, or reliability."
},
{
"name": "Best Bus Service Nhavare Shirur",
"description": "Best Bus Service Nhavare Shirur is trusted for punctuality, clean buses, transparent pricing, and customer satisfaction provided by Sanavi Travels."
}
],
"tableData": [
["Bus On Rent in Nhavare Shirur", "Bus Hire Nhavare Shirur"],
["AC Bus Rental Nhavare Shirur", "Non AC Bus Hire Nhavare Shirur"],
["Luxury Bus Nhavare Shirur", "Mini Bus Hire Nhavare Shirur"],
["32 Seater Bus Nhavare Shirur", "35 Seater Bus Nhavare Shirur"],
["Wedding Bus Nhavare Shirur", "Corporate Bus Nhavare Shirur"],
["Picnic Bus Nhavare Shirur", "Outstation Bus Nhavare Shirur"],
["Bus Hire Nhavare Shirur with Driver", "Affordable Bus Rental Nhavare Shirur"],
["Best Bus Service Nhavare Shirur", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Nhavare Shirur with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and professional bus rental services in Nhavare Shirur for all group travel needs."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Buses",
    "WhyChoosedescription": "All buses are regularly serviced and cleaned to ensure maximum passenger comfort."
  },
  {
    "WhyChooseheading": "Experienced Local Drivers",
    "WhyChoosedescription": "Drivers are familiar with Nhavare, Shirur, industrial zones, and highways."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "Clear and upfront pricing with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Round-the-clock assistance for bookings and journey coordination."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Hourly, full-day, and outstation rental plans available."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "Buses are sanitized before every trip for passenger safety."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "Guaranteed punctual pickups and smooth operations."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Nhavare Shirur?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services in Nhavare Shirur.'
  },
  {
    question: 'What types of buses are available in Nhavare Shirur?',
    answer: 'AC buses, Non AC buses, mini buses, luxury buses, 32-seater and 35-seater buses are available.'
  },
  {
    question: 'Is bus rental available for weddings and picnics?',
    answer: 'Yes, we provide dedicated buses for weddings, picnics, and social events.'
  },
  {
    question: 'Can I book a bus for outstation travel from Nhavare Shirur?',
    answer: 'Yes, outstation bus rentals are available from Nhavare Shirur.'
  },
  {
    question: 'Are the buses sanitized?',
    answer: 'Yes, all buses are sanitized before every journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sunil Pawar',
    feedback: 'We booked a bus from Nhavare Shirur for a wedding. Very smooth and well-managed service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Rutuja Jadhav',
    feedback: 'Sanavi Travels provided a clean AC bus for our picnic trip from Nhavare. Highly satisfied.',
    rating: 5
  }
];




















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus On Rent in Nhavare Shirur - Sanavi Travels",
  "description": "Sanavi Travels offers bus on rent in Nhavare Shirur for weddings, corporate travel, picnics, and outstation trips. We provide AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};






  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus On Rent in Nhavare Shirur | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus on rent in Nhavare Shirur with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for weddings, corporate travel, picnics, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/234.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinnhavareshirur;